module.exports = "/_next/static/images/7cdbf23ffb83ac95a6eec481a0d6d7f0-holding-device-smile@0.5x.jpg";